import useTestTag from '../../common/hooks/use-test-tag';
import OdinIcon, { OdinIconSize, type OdinIconName } from '../odin-icon/odin-icon.component';

export enum OdinIconPosition {
  Left,
  Right,
}

export interface OdinMenuItem {
  name: string;
  itemIconName: OdinIconName;
  itemIconPosition?: OdinIconPosition;
  menuItemText: string;
}

export interface OdinIconMenuItemProps extends OdinMenuItem {
  onClick: (name: string) => void;
}

export default function OdinIconMenuItem({
  name,
  itemIconName,
  itemIconPosition = OdinIconPosition.Left,
  menuItemText,
  onClick,
}: OdinIconMenuItemProps) {
  const tagCreator = useTestTag('odin-icon-menu');

  return (
    <div
      className="odin-flex odin-cursor-pointer odin-items-center odin-p-1 hover:odin-bg-primary-5"
      onClick={() => onClick(name)}
    >
      {itemIconPosition === OdinIconPosition.Left && (
        <div className="odin-mr-1 odin-shrink">
          <OdinIcon icon={itemIconName} size={OdinIconSize.ExtraSmall} />
        </div>
      )}
      <div className="odin-grow" ref={tagCreator(`${(menuItemText ?? '').replace(/\s+/g, '-').toLowerCase()}`)}>
        {menuItemText}
      </div>
      {itemIconPosition === OdinIconPosition.Right && (
        <div className="odin-ml-1 odin-shrink">
          <OdinIcon icon={itemIconName} size={OdinIconSize.ExtraSmall} />
        </div>
      )}
    </div>
  );
}
